import { h, defineComponent, ref } from 'vue';
import animationData from '@/assets/animations/poppy_confetti.json';

export const PoppyConfetti = defineComponent({
  name: 'PoppyConfetti',
  setup(_, { emit }) {
    const animationFinished = ref(false);
    const complete = (source: { stop: () => void }) => {
      source.stop();
      emit('complete');
      animationFinished.value = true;
    };

    return function render() {
      return h('div', {
        class: 'lottie-animation',
      }, [
        h('lottie', {
          class: `lottie-animation__poppy-confetti${animationFinished.value ? ' lottie-animation--finished' : ''}`,
          props: {
            animationData,
            loop: false,
            autoPlay: true,
          },
          on: {
            complete,
          },
        }),
      ]);
    };
  },
});
